import * as React from 'react';
import Status from '../../../core/types/Status';
import Modal from '../../../core/components/Modal/Modal';
import { DataTableHeader } from '../../../core/components/Table/types/DataTableHeader';
// @ts-ignore
import styles from './PayAllCustomerTransactionsTile.module.scss';
import { PayCasesVM } from './types/PayCasesVM';
import { PayableItem } from './types/PayableItem';
import { CustomerTransaction } from './types/CustomerTransaction';
import { InfoMessageService, TranslationService } from '../../../core/services';
import { Alert, Button, Loader, ModuleContainer, Table } from '../../../core/components';
import ApiProvider from '../../../core/api/ApiProvider';

type Props = {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onPayInvoice: (payCase: PayableItem) => void;
};

const CasesModal = (props: Props) => {
  const { isOpen, onToggle } = props;
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [model, setModel] = React.useState<PayCasesVM>({} as PayCasesVM);

  const fetchData = async () => {
    try {
      const data = await getPayAllCases();
      setModel(data.data);
      if (!data.success) {
        InfoMessageService.error(data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getPayAllCases = async () => {
    return await ApiProvider.post<Status<PayCasesVM>>(
      'PayAllCustomerTransactionsTileModule/GetPayAllCases'
    );
  };

  const tableHeaders: DataTableHeader[] = [
    {
      headerName: TranslationService.translate('DocumentNo'),
      columnName: 'invoiceNo',
      isVisible: true,
    },
    {
      headerName: TranslationService.translate('BalanceToPay'),
      columnName: 'balanceAmount',
      cssClassNames: '',
      isVisible: true,
      formatter: (value: any, row: CustomerTransaction) => (
        <>
          {row.balanceAmount} <em className="currency-symbol">{model.currency}</em>
        </>
      ),
    },
    {
      headerName: '',
      columnName: 'actions',
      cssClassNames: '',
      isVisible: true,
      formatter: (value: any, invoice: CustomerTransaction) => (
        <Button
          variant={Button.Variants.Primary}
          type={Button.Types.Button}
          onClick={() =>
            props.onPayInvoice({
              accountNo: invoice.accountNo.toString(),
              debtorNo: invoice.debtorNo,
              creditorNo: invoice.creditorNo,
              invoiceNo: invoice.invoiceNo,
              itemType: 1,
              sourceTenantId: invoice.sourceTenantId,
            })
          }
        >
          {TranslationService.translate('PayNow')}
        </Button>
      ),
    },
  ];

  React.useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      fetchData();
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onToggle={onToggle}
        className={styles.modalWrapper}
        closeBtnClass="modal-close-btn"
      >
        <ModuleContainer classNames="mt-0 mb-0" variant={ModuleContainer.ModuleVariant.Variant1}>
          <ModuleContainer.Header
            title={TranslationService.translate('TabModule_CustomersTrxHeader')}
          />
          <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Primary}>
            {isLoading && <Loader opacity={0.4} />}
            {model.payInvoices && model.payInvoices.length > 0 ? (
              <Table
                headers={tableHeaders}
                rows={model.payInvoices}
                keyField="invoiceNo"
                paginationProps={{
                  hideSizePerPage: true,
                  hidePageListOnlyOnePage: true,
                }}
              />
            ) : (
              !isLoading && (
                <Alert variant={Alert.Variants.Info}>
                  {TranslationService.translate('PayAllTile_NothingToPay')}
                </Alert>
              )
            )}
          </ModuleContainer.Body>
        </ModuleContainer>
      </Modal>
    </>
  );
};

export default CasesModal;
